import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/inspectGroup/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/inspectGroup/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/inspectGroup/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/inspectGroup/save', params, options);

export const update = (params, options) =>
  request.post('/api/inspectGroup/update', params, options);

export const getUserList = () => request.get('api/blade-user/userTree');

export const getInspectGroupTree = (id) => {
  return request({
    url: 'api/inspectGroup/inspectGroupTree',
    method: 'get',
    params: {
      id,
    },
  });
};
